const notificationtemplates = {
	title: "Varslingsmaler",
	new_notificationtemplate: "Ny mal",
	edit_notificationtemplate: "Rediger mal: {name}",
	view_notificationtemplate: "Vis mal: {name}",
	list_title: "Epost maler",
	create_title: "Opprett epostmal",
	update_title: "Oppdater epostmal",
	id: "ID",
	tags_title: "Varslingsmal-tagger",
	subject: "Emne",
	template: "Mal",
	trigger: "Trigger",
	description: "Kort beskrivelse",
	slug: "Slug",
	tag: "Tags",
	type: "Type",
	available_tags: "Tilgjengelig tags",
};
export default notificationtemplates;